import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tremendous = defineConnector({
  identifier: "tremendous",
  name: "Tremendous",
  tagLine: "Rewards and payouts",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.tremendous\\.com/api/v2/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Tremendous app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Tremendous Developer Portal](https://developers.tremendous.com/) and create an application to get your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/tremendous/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Tremendous account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Tremendous account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://api.tremendous.com/oauth/authorize",
    tokenEndpoint: () => "https://api.tremendous.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tremendous.com/api/v2/me",
  },
});
